import React from "react";
import { Tooltip } from "../../../../../../components/tooltip/tooltip/tooltip.component";
import { TooltipTitle } from "../../../../../../components/tooltip/tooltip-title/tooltip-title.component";
import { TooltipBody } from "../../../../../../components/tooltip/tooltip-body/tooltip-body.component";
import { withShowIf } from "../../../../../../components/with-show-if/with-show-If.component";
import { BASE_COLORS } from "../../../../../../emotion-theme";
import { ErrorIcon } from "../../../../../../components/icon/icons/error-icon.component";
import { ProductStatusIndicatorTooltipProps } from "../../types/product-status-indicator-tooltip.props";

export const ProductStatusIndicatorTooltipRemoved = withShowIf(
  (props: ProductStatusIndicatorTooltipProps) => (
    <Tooltip colour={BASE_COLORS.red} icon={ErrorIcon}>
      <TooltipTitle>{props.field} Update</TooltipTitle>
      <TooltipBody>{props.field} has been removed by the system.</TooltipBody>
    </Tooltip>
  )
);
